import React from 'react';
import './SystemsReview.css';

const SystemsReview = ({ systemsReview, onChange }) => {
  const handleAnswerChange = (field, answer) => {
    onChange({
      ...systemsReview,
      [field]: {
        ...systemsReview[field],
        answer: answer,
        // Clear details if answer is No
        details: answer ? systemsReview[field]?.details || '' : ''
      }
    });
  };

  const handleDetailsChange = (field, details) => {
    onChange({
      ...systemsReview,
      [field]: {
        ...systemsReview[field],
        details: details
      }
    });
  };

  const systemsFields = [
    { key: 'aparatoDigestivo', label: 'Aparato digestivo' },
    { key: 'aparatoRespiratorio', label: 'Aparato respiratorio' },
    { key: 'aparatoCardiovascular', label: 'Aparato cardiovascular' },
    { key: 'aparatoGenitourinario', label: 'Aparato genitourinario' },
    { key: 'sistemaEndocrino', label: 'Sistema endocrino' },
    { key: 'sistemaHematopoyetico', label: 'Sistema hematopoyético' },
    { key: 'sistemaNervioso', label: 'Sistema nervioso' },
    { key: 'sistemaMusculoEsqueletico', label: 'Sistema músculo esquelético' },
    { key: 'aparatoTegumentario', label: 'Aparato tegumentario' }
  ];

  return (
    <div className="systems-review-section">
      <div className="systems-review-title">APARATOS Y SISTEMAS</div>
      
      <div className="systems-review-grid">
        {systemsFields.map((field) => {
          const fieldData = systemsReview[field.key] || { answer: null, details: '' };
          return (
            <div key={field.key} className="system-field">
              <div className="system-row">
                <label className="system-label">{field.label}</label>
                <div className="radio-group">
                  <div className="radio-option">
                    <input
                      type="radio"
                      id={`${field.key}-si`}
                      name={field.key}
                      checked={fieldData.answer === true}
                      onChange={() => handleAnswerChange(field.key, true)}
                    />
                    <label htmlFor={`${field.key}-si`}>Sí</label>
                  </div>
                  <div className="radio-option">
                    <input
                      type="radio"
                      id={`${field.key}-no`}
                      name={field.key}
                      checked={fieldData.answer === false}
                      onChange={() => handleAnswerChange(field.key, false)}
                    />
                    <label htmlFor={`${field.key}-no`}>No</label>
                  </div>
                </div>
              </div>
              
              {fieldData.answer === true && (
                <div className="details-row">
                  <input
                    type="text"
                    value={fieldData.details || ''}
                    onChange={(e) => handleDetailsChange(field.key, e.target.value)}
                    placeholder="Especificar detalles..."
                    maxLength="500"
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SystemsReview;
